export const ROUTE_STATION_SERVICES_FILTERS = {
  all: 'all',
  top5ByCountry: 'top5ByCountry',
  topPriceEvery100km: 'topPriceEvery100km'
} as const;

export const STATION_SERVICE_PRICE_TYPES = {
  inCountry: 'inCountry',
  inEUR: 'inEUR'
} as const;

export const STATION_SERVICES_SORTING = {
  default: 'default',
  hight: 'hight',
  low: 'low'
} as const;
